import React, { useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useSelector } from "react-redux";
import Swal from 'sweetalert2';
import { Link, useNavigate } from 'react-router-dom';
import Layout from '../../layouts/Layout';
import { FaStarOfLife } from 'react-icons/fa';
import Loader from '../components/Loader';
import { createBlogAPI } from '../../services/api/BlogAPI';
import ReactQuill from 'react-quill';

const AddBlog = () => {
    const user = useSelector((state) => state.LoginReducer.authData);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const validationSchema = Yup.object({
        title: Yup.string()
            .min(3, 'Title must be at least 3 characters long')
            .required('Title is required'),
        description: Yup.string()
            .required('Description is required'),
        image: Yup.mixed()
            .required('Image is required')
            .test('fileType', 'Only JPEG and PNG files are allowed', (value) => {
                return value && (value.type === 'image/jpeg' || value.type === 'image/png');
            })
            .test('fileSize', 'File size exceeds the 2MB limit', (value) => {
                return value && value.size <= 2 * 1024 * 1024; // 2MB limit
            }),
    });

    const formik = useFormik({
        initialValues: {
            title: '',
            description: '',
            image: null,
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            setLoading(true);
            const formData = new FormData();
            formData.append('title', values.title);
            formData.append('description', values.description);
            formData.append('image', values.image);
            await createBlog(formData);
        },
    });

    // Handle image change
    const handleImageChange = (event) => {
        const file = event.currentTarget.files[0];
        formik.setFieldValue('image', file);
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                formik.setFieldValue('imagePreview', reader.result);  // Add a preview state if necessary
            };
            reader.readAsDataURL(file);
        }
    };

    const createBlog = async (formData) => {
        try {
            const token = user.data.token;
            const data = await createBlogAPI(formData, token);
            setLoading(false);
            if (data.status) {
                Swal.fire({
                    title: 'Blog Created!',
                    text: 'The Blog has been created successfully.',
                    icon: 'success',
                    confirmButtonText: 'OK',
                }).then(() => {
                    navigate('/blogs');
                });
            }
        } catch (error) {
            setLoading(false);
            Swal.fire({
                title: 'Error!',
                text: 'Something went wrong please try again.',
                icon: 'error',
                confirmButtonText: 'OK',
            });
        }
    };

    const modules = {
        toolbar: [
          [{ 'header': '1'}, {'header': '2'}, { 'font': [] }],
          [{ 'list': 'ordered'}, { 'list': 'bullet' }],
          ['bold', 'italic', 'underline', 'strike', 'blockquote'],
          ['link', 'image'],
          [{ 'align': [] }],
          ['clean']
        ],
    };

    if (loading) {
        return <Loader />;
    }

    return (
        <Layout title="Create Blog">
            <div className="container table-container">
                <form onSubmit={formik.handleSubmit}>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-12 col-12">
                                <div className="form-group py-3 required">
                                    <label htmlFor="title">Blog Title <FaStarOfLife className='text-danger' /></label>
                                    <input type="text" className="form-control mt-1" name="title" id="title" placeholder="Enter Blog name" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.title} />
                                </div>
                                {formik.touched.title && formik.errors.title ? ( <label className="text-danger">{formik.errors.title}</label>) : null}
                            </div>
                            <div className="col-md-12 col-12">
                                <div className="form-group py-2 required">
                                    <label htmlFor="description">Description <FaStarOfLife className='text-danger' /></label>
                                    <ReactQuill className='mt-1 mb-5' modules={modules} value={formik.values.description} onChange={(value) => formik.setFieldValue('description', value)} theme="snow" style={{ height: '150px', borderRadius: '8px' }}  placeholder="Start typing..." />
                                    {formik.touched.description && formik.errors.description ? ( <label className="text-danger">{formik.errors.description}</label>) : null}
                                </div>
                            </div>
                            <div className="col-md-6 col-12">
                                <div className="form-group py-2 required">
                                    <label htmlFor="image">Blog Image <FaStarOfLife className='text-danger' /></label>
                                    <input type="file" className="form-control mt-1" name="image" id="image" accept="image/*" onChange={handleImageChange} />
                                </div>
                                {formik.touched.image && formik.errors.image ? ( <label className="text-danger">{formik.errors.image}</label>) : null}
                            </div>
                            {formik.values.imagePreview && (
                                <div className="col-md-6">
                                    <img className='image-preview' src={formik.values.imagePreview} alt="Image Preview" />
                                </div>
                            )}
                        </div>
                        <div className="row mt-3">
                            <div className="col-md-6 col-12 d-flex gap-3">
                                <Link to={'/blogs'} type="submit" className="btn btn-dark cancel_btn">Cancel</Link>
                                <button type="submit" className="btn btn-primary submit_btn">Submit</button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </Layout>
    )
}

export default AddBlog;